import pages from '@/enums/pages.json';
import { last, secondLast } from '@/utils/lib';

export const isGame = state => last(state.page) === pages.game;

export const isResult = state => last(state.page) === pages.result;

export const openedFrom = state => {
  if (state.page.length > 1) {
    const from = secondLast(state.page);
    return `/${from}`;
  }
  return '/';
};
